import { typeLabel, typeMeta } from "@/lib/fieldDependencyConstants";

/** Coloured reference-type pill (read / write / assign / compare / key / join / call parm / unknown). */
export default function TypeBadge({ type, count, testid, className = "" }) {
  const m = typeMeta(type);
  return (
    <span
      className={`inline-flex items-center gap-1 ml-mono text-[10px] uppercase tracking-widest px-1.5 py-0.5 border whitespace-nowrap ${className}`}
      style={{ background: m.bg, color: m.fg, borderColor: m.border, borderStyle: type === "unknown" ? "dashed" : "solid" }}
      title={m.hint}
      data-testid={testid || `type-badge-${type}`}
      data-type={type}
    >
      {typeLabel(type)}
      {count != null && <span className="tabular-nums opacity-80">{count}</span>}
    </span>
  );
}
